import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { FieldModel } from '../../../../../models/form/field';
import { FieldType } from '../../../../../models/form/fieldType';
import OptionListOptions from './fields/OptionListOptions';
import PaymentListOptions from './fields/PaymentListOptions';
import { selectedFieldSelector } from '../../../../../slices/formadmin';
import ProductsOptions from './fields/ProductsOptions';

const FieldOptions: FC = () => {
  const field = useSelector(selectedFieldSelector) as FieldModel;

  if (!field) {
    return null;
  }

  switch (field.type) {
    case FieldType.Select:
    case FieldType.OptionList:
      return <OptionListOptions />;
    case FieldType.PaymentOptionList:
    case FieldType.PaymentChoiceList:
      return <PaymentListOptions />;
    case FieldType.Products:
      return <ProductsOptions />;
  }
  return null;
};

export default FieldOptions;
